<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingdmain/orderNxKaipiao',title:'代理商签收'},{title:'冷库签收审批'}]"/>
        <!---------------------------------------------------项目信息-------------------------------------------------------------------->
        <div class="h-piece ddform_disable_cls" style="margin:20px">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>订单信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="订单类型" class="h-elformWrap-2">
                                <el-input v-model="xsqyStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="销售组织" class="h-elformWrap-2">
                                <el-input v-model="xszzStr" readonly></el-input>
                            </el-form-item>

                            <el-form-item label="创建人" class="h-elformWrap-2">
                                <el-input v-model="this.order.cuname" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建时间" class="h-elformWrap-2">
                                <el-input v-model="this.order.cdate" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="是否自动化冷库" class="h-elformWrap-2">
                                <brselect disabled category="shifou_keyong" :v="this.order.isZdlk" v-model="this.order.isZdlk"></brselect>
                            </el-form-item>
                            <el-form-item label="是否直单" class="h-elformWrap-2">
                                <brselect disabled category="shifou_keyong" :v="this.order.isZhidan" v-model="this.order.isZhidan"></brselect>
                            </el-form-item>
                            <el-form-item v-if="(this.order.isZdlk == '1') " prop="fileUrl" label="冷库签收附件"
                                          class="h-elformWrap-2">
                                <brupload
                                    :refid=this.order.sapCode
                                    reftype="NX_ZDLK"
                                    :showtime="false"
                                >
                                </brupload>
                            </el-form-item>
                            <el-form-item v-if="(this.order.isZhidan == '1') " prop="fileUrl" label="直单签收附件"
                                          class="h-elformWrap-2">
                                <brupload
                                        :refid=this.order.sapCode
                                        reftype="NX_ZD"
                                        :showtime="false"
                                >
                                </brupload>
                            </el-form-item>

                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>客户信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="order" ref="form1" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item prop="soldToName" label="售达方名称" class="h-elformWrap-2">
                                <el-input v-model="order.soldToName" placeholder="请输入" readonly>
                                </el-input>
                            </el-form-item>

                            <el-form-item prop="soldToAreaName" label="售达方区域"    class="h-elformWrap-2">
                                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
                            </el-form-item>

                            <el-form-item label="销售区域" class="h-elformWrap-2">
                                <el-input v-model="order.salesregionName" readonly placeholder="自带出"></el-input>
                            </el-form-item>
                            <el-form-item prop="customerChannelCode" label="客户渠道" class="h-elformWrap-2">
                                <brselect
                                    :disabled="true"
                                    category="sales_region" :v="order.customerChannelCode"
                                    v-model="order.customerChannelCode"></brselect>
                            </el-form-item>
                            <el-form-item prop="toCompanyname" label="收货单位" class="h-elformWrap-2">
                                <el-input v-model="order.toCompanyname" :class="{'addredclass':regionaddflag}" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="收货地址" prop="toAddress" class="h-elformWrap-2">
                                <el-input  v-model="order.toAddress" :title="order.toAddress" readonly>
                                </el-input>
                            </el-form-item>

                            <el-form-item prop="contactName" label="收货联系人" class="h-elformWrap-2">
                                <el-input v-model="order.contactName" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="联系电话" class="h-elformWrap-2" prop="firsttelephone">
                                <div class="block">
                                    <el-input v-model="order.firsttelephone" readonly
                                    ></el-input>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
            <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
            <div  class="h-table h-mrt30 ljjtablepaddings" style="margin: 20px 20px 0 20px;">
                <div class="h-pieceTitle2 message">
                    <h1 >产品信息</h1>
                </div>
                <div v-for="obj in productlist1">
                        <span style="color: #4a4a4a">{{ obj.name }}</span>
                        <el-table
                            ref="multipleTable"
                            :data="getProductlist(obj.code)"
                            stripe
                            border
                            style="width: 100%">

                            <el-table-column
                                type="index"
                                label="#"
                                width="30">
                            </el-table-column>
                            <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="80">
                            </el-table-column>
                            <el-table-column
                                prop="sapCode"
                                label="订单号"
                                :show-overflow-tooltip="true"
                                width="100">
                            </el-table-column>
                            <el-table-column
                                prop="materialCode"
                                label="产品编码"
                                :show-overflow-tooltip="true"
                                width="100">
                            </el-table-column>
                            <el-table-column
                                prop="materialName"
                                label="产品名称"
                                min-width="150"
                                :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div style="text-align: left;">
                                        {{scope.row.materialName}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="oemDesc"
                                label="规格型号"
                                min-width="180"
                                :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div style="text-align: left;">
                                        {{scope.row.oemDesc}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="factory"
                                label="产地"
                                :show-overflow-tooltip="true"
                                width="60">
                            </el-table-column>

                            <el-table-column
                                prop="ycid"
                                label="退货订单号"
                                v-if="order.orderCategory1=='14'"
                                min-width="140">
                                <template slot-scope="scope">
                                    {{scope.row.ycid}}
                                </template>
                            </el-table-column>

                            <el-table-column
                                prop="proNumber"
                                label="退货数量"
                                :show-overflow-tooltip="true"
                                v-if="order.orderCategory1=='14'"
                                width="50">
                                <template slot-scope="scope">
                                    {{scope.row.proNumber}}
                                </template>
                            </el-table-column>

                            <el-table-column
                                prop="proNumber"
                                label="订单数量"
                                v-if="order.orderCategory1!='14'"
                                width="50">
                                <template slot-scope="scope">
                                    <div style="text-align: right;">
                                        {{scope.row.proNumber}}
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column
                                prop="proBenchmarkPrice"
                                :label="priceName"
                                :show-overflow-tooltip="true"
                                width="70">
                            </el-table-column>

                            <el-table-column
                                prop="currencyCode"
                                label="币种"
                                :show-overflow-tooltip="true"
                                width="80">
                            </el-table-column>

                            <el-table-column
                                prop="finalPrice"
                                label="成交价"
                                :show-overflow-tooltip="true"
                                width="110">
                                <template slot-scope="scope">
                                    <div style="text-align: right;">
                                        {{scope.row.finalPrice}}
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column
                                prop="taxRate"
                                label="税率"
                                v-if="order.orderCategory1 == 9"
                                width="110">
                                <template slot-scope="scope">
                                    <!--<div style="text-align: right;">
                                        {{new big(scope.row.taxRate||0).times(100).minus(100).toString() + '%'}}
                                    </div>-->
                                    <el-select class="h-tableInput" :disabled="taskstatus != '0'"
                                               @input="changeTax($event,scope.row)" v-model="scope.row.taxCode" placeholder="请选择" >
                                        <el-option label="0%" value="J0"></el-option>
                                        <el-option label="6%" value="JQ"></el-option>
                                        <el-option label="13%" value="JC"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>

                            <el-table-column
                                prop="jinejjz"
                                label="净价值"
                                :show-overflow-tooltip="true"
                                width="110">
                                <template slot-scope="scope">
                                    <div style="text-align: right;">
                                        {{ scope.row.jinejjz}}
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column
                                prop="totalprice"
                                label="总价"
                                :show-overflow-tooltip="true"
                                width="110"
                            >
                                <template slot-scope="scope">
                                    <div style="text-align: right;">
                                        {{scope.row.totalprice}}
                                    </div>
                                </template>
                            </el-table-column>


                            <el-table-column
                                prop="note1"
                                label="备注"
                                :show-overflow-tooltip="true"
                            >
                                <template slot-scope="scope">
                                    <div style="text-align: right;">
                                        {{scope.row.note1}}
                                    </div>
                                </template>
                            </el-table-column>

                        </el-table>

                    </div>
            </div>
            <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        </div>

        <div class="h-table h-mrt30    bbbb" v-if="this.taskstatus == '0'">
            <div class="h-pieceTitle2 hang">
                <h1 class="h1">审批意见</h1>
                <el-form :model="spform" label-position="right" :inline="true"
                         class="demo-ruleForm h-formbLine ">
                    <el-form-item label="上传附件" v-if="uploadFlag" class="h-elformWrap-2 " style="margin:30px 0 20px 23px" :required="true">
                        <brupload
                            :refid="order.id"
                            reftype="服务订单审批附件"
                            :limit="1"
                            :showtime="false" uploadflag delflag
                        >
                        </brupload>
                    </el-form-item>
                    <el-form-item label="审批意见" class="h-elformWrap-2 " style="margin:30px 0 20px 23px" :required="true">
                        <el-input v-model="spform.shpyj" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="anniu" v-if="this.taskstatus == '0'">
            <el-button  @click="backtolist" class="el-button h-btn h-bBtn h-bgwhite el-button--default" >返回</el-button>
            <el-button class="el-button h-btn h-bBtn h-bgred el-button--default" @click="approve(2)">驳回</el-button>
            <el-button class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="approve(1)">通过</el-button>
            <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
        </div>
        <div class="anniu" v-if="this.taskstatus == '1'">
            <el-button  @click="backtolist" class="el-button h-btn h-bBtn h-bgwhite el-button--default" > 返回</el-button>
            <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
        </div>
    </div>
</template>

<script>
import big from 'big.js'
import ss from '../../api/SystemService'


export default {

    data() {
        return {
            regionaddflag:false,
            uploadFlag:false,
            priceName:"基准价",
            showService:false,
            showIsFree:false,
            costList:[],
            instid:null,
            spform:{
                ywid:null,
                taskid:null,
                taskstatus:null,
                optflag:null,
                shpyj:null,
            },


            showhistory:false,


            disabled:false,
            areaList:[],
            areaUserList:[],
            order:{

                sapCode:null,//订单号
                fktj:null,
                gjmytk:null,
                id:null, // 主键
                orderMainContract:null, // 主合同编号
                orderSubContract:null, // 分合同编号
                orderProjectCode:null, // 项目编号
                orderProjectName:null, // 项目名称
                orderCategory:null, // 订单类型
                orderCategory1:null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
                saleGroupCode:null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织
                disChannelCode:null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
                zCode:null, // 分销渠道编码-子编码
                customerChannelCode:null, // 客户渠道
                isStockUp:null, // 是否备货      1：是；0：否
                orderStatus:null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
                instid:null, // 流程id
                tuihyy:null, // 退货原因
                tuihyydes:null, // 退货原因说明
                contactName:null, // 联系人名称
                receivedTime:null, // 预计收货时间
                soldToCode:null, // 售达方编码
                soldToName:null, // 售达方名称
                soldToAreaCode:null, // 售达方地区编码
                shipToCode:null, // 送达方编码
                shipToName:null, // 送达方名称
                shipToAreaCode:null, // 送达方地区编码
                invoiceCode:null, // 开票方编码
                payerCode:null, // 付款方编码
                currencyCode:null, // 币种编码
                orderPrice:null, // 订单总价
                orderPriceXj:null, // 订单现金占用
                creditid:null, // 信贷id
                orderPriceXd:null, // 订单信贷占用
                orderNetWorth:null, // 订单净价值
                poId:null, // PO号
                areaId:null, // 区域详情表关联id
                dcCode:null, // 配送中心编码
                toProvincesCode:null, // 送达省份编码
                toCityCode:null, // 送达城市编码
                note:null, // 订单备注
                postcode:null, // 邮政编码
                firsttelephone:null, // 第一个电话
                secondtelephone:null, // 第二电话
                extraPrice:null, // 定制加价
                customized:null, // 定制需求
                sapsended:null, // 是否已提交sap,1-是,0-否
                toAddress:null, // 收货地址
                toCompanyname:null, // 送达方公司全称
                posnr:null, // 外销:销售和分销凭证的项目号
                inco1:null, // 外销:国际贸易条款 (部分1)
                inco2:null, // 外销:国际贸易条款 (部分2)

                categoryName:null,
                category1Name:null,
                saleGrputName:null,
                disChannelName:null,
                zcodeName:null,

                boxing:null,
                boxNum:null,
                attachment:null,
                isZdlk:null,
                isZhidan:null,

            },

            //产品list
            productlist1:[],
            gscode: null,
            //用户信贷list
            creditData:[],

        }
    },
    //页面加载前事件
    created() {
        let id = this.$route.query.ywid || this.$route.query.id;
        let instid = this.$route.query.instid;
        let taskid = this.$route.query.taskid;
        let taskstatus = this.$route.query.taskstatus;

        this.instid = instid;
        this.taskstatus = taskstatus;
        this.spform.ywid = id;
        this.spform.taskid = taskid;
        this.getKaipiaoById(id);
    },

    computed:{
        xsqyStr() {
            this.disabled = false;
            if(this.order.category1Name){
                if(this.order.category1Name =='标准自产订单' || this.order.category1Name =='标准OEM订单' || this.order.category1Name =='国内外贸公司订单'){
                    this.disabled = true;
                }
                return this.order.categoryName +"/"+ this.order.category1Name
            }
            return this.order.categoryName
        },
        xszzStr() {
            return "(" + this.gscode + ")" + this.$store.getters.dictname('YLSalesOrganization_agent', this.gscode);

        },

    },


    methods: {

        getKaipiaoById(id) {
            ss.OrderMainService.getKaipiaoById(id).then(rd => {
                _.assign(this.order, rd.order)
                console.log('我在这儿呀', this.order);
                this.order.isZdlk = rd.obj.isZdlk;

                this.order.isZhidan = rd.obj.isZhidan;

                this.ddlx = this.order.orderCategory+","+(this.order.orderCategory1||'');
                var type = this.order.orderCategory1||'';

                //存在行项目
                if (rd.order.products && rd.order.products.length > 0) {
                    this.order.costCenter = rd.order.products[0].costCenter;
                    rd.order.products.forEach((obj) => {
                        this.gscode = obj.gscode;
                        if(!this.order.sapCode){
                            this.order.sapCode=obj.sapCode;
                        }
                        this.productlist1.push(obj);
                    })
                }

            })
        },
        //根据公司编码返回productlist
        getProductlist(code){
            return this.productlist1
        },
        viewpress(r){
            this.showhistory = true;
        },
        backtolist() {
            this.$router.go(-1);
        },
        approve(v) {
            if (v == '2') {
                this.spform.optflag = '驳回'
                if(!this.spform.shpyj){
                    this.$msg.msge("驳回必须输入审批意见！");
                    return;
                }
            } else if (v == '1') {
                this.spform.optflag = '通过'
            } else {
                this.$store.dispatch("searchTasktotal")
                //跳转回系统的代办列表
                //this.$router.push({path:'/personal/dealCenter'});
                this.$router.go(-1);
                return;
            }
            this.$msg.confirm("确认提交？", () => {
                this.submitForm();
            })
        },
        submitForm() {
            ss.OrderMainService.approveLKKaipiao(this.spform).then(rd => {
                this.$msg.alerts("提交成功！",()=>{
                    //刷新右上角的代办个数
                    this.$store.dispatch("searchTasktotal")
                    //跳转回原页面
                    //this.$router.go(-1);
                    this.$router.push({path: '/personal/dealCenter'});
                })
            })
        },

    }
}

</script>


<style scoped>
.queren {
    background-color: #006aca;
    color: white;
}
.anniu {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.jieguo {
    border-bottom: 1px solid rgb(238, 236, 236);
    display: flex;
}
.jieguo .jieguo_label{
    width: 2.5rem;
    text-align: right;
    background-color: #ebf5ff;
    font-size: 0.16rem;
    color: #616467;
    height: 0.4rem;
    line-height: 0.4rem;
    padding: 0 0.12rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.jieguo .jieguo_value{
    width: 20%;
    font-size: 0.16rem;
    color: #616467;
    padding: 0px 8px;
    height: 0.4rem;
    line-height: 0.4rem;
}
img {
    width: 25px;
    padding: 5px 0;
    margin-left: 8rem;
}

.newProject {
    margin: 0 20px;
    background-color: rgb(94, 182, 233);
}

/* .h-crumbOut {
    margin-bottom: 20px;
} */

.h-piece {
    margin: 20px;
}
.h1 {
    margin-left: 27px;
}
.message {
    padding: 20px 0;
    margin-bottom: 0;
    background-color: white;
}
.n-xiao .h-formbLine .h-elformWrap-2,
.n-two .h-formbLine .h-elformWrap-2 {
    width: 33.333%;
}
</style>
<style>
.n-two .h-formbLine .el-form-item__content .el-select,
.n-two .el-form .h-formbLine .el-form-item__content .el-select {
    width: 0;
}
.n-xiao .h-formbLine .el-form-item__label,
.n-two .h-formbLine .el-form-item__label {
    width: 43%;
}

.n-xiao .h-formbLine .el-form-item__content,
.n-two .h-formbLine .el-form-item__content {
    width: 57%;
}

.bbbb {
    padding-top: 5px;
    margin: 0 20px;
}
.hang {
    padding: 20px 0;
    margin-bottom: 0;
    background-color: white;
}
.ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
    color: #868686;
}
</style>

